'use client'

import { ModalTypes } from '@/interfaces/api/generic/api_modals_types'
import styles from './VPadBanner.module.css'
import { useModalStore } from '@/stores/useModalStore'
import VPadPairingModal from '../Modals/VPadPairingModal/VPadPairingModal'
import VPadIcon from '@/assets/img/Icon_VPad.svg'
import RightChevronIcon from '@/assets/img/Icon_ChevronRight.svg'
import { useTranslations } from 'next-intl'
import { usePadsStore } from '@/stores/usePadsStore'
import { PadSessionManager } from '@/services/VirtualPad/PadSessionManager'
import GamepadsModal from '../Modals/GamepadsModal/GamepadsModal'
import { toast } from 'react-toastify'
import Notification from '../Notification/Notification'
import { useState } from 'react'
import { VPadStage } from '@/interfaces/virtualPad_types'

export default function VPadBanner () {
  const t = useTranslations('Game.vPadBanner')
  const te = useTranslations('Errors')
  const openModal = useModalStore(state => state.openModal)
  const vpadsRecord = usePadsStore((state) => state.vpads)

  const [connecting, setConnecting] = useState(false)

  const vpads = Object.values(vpadsRecord)
  const connectedVPads = vpads.filter((vPad) => vPad.stage === VPadStage.CONNECTED)
  const suspendedVPads = vpads.filter((vPad) => vPad.stage === VPadStage.SUSPENDED)

  /**
   * Handles the click on banner
   */
  async function handleClickBanner () {
    if (connecting) return

    try {
      setConnecting(true)
      
      await PadSessionManager.getInstance().startSession()

      if (connectedVPads.length > 0 || suspendedVPads.length > 0) showGamepadsModal()
      else showVPadPairingModal()
    } catch(error) {
      console.error('Could not start virtual pad session:', error)
      toast.error(<Notification text={te('defaultUnknowError')} />)
    } finally {
      setConnecting(false)
    }
  }

  /**
   * Show the gamepads modal
   */
  function showGamepadsModal () {
    openModal({
      type: ModalTypes.LATERAL,
      content: <GamepadsModal />
    })
  }

  /**
   * Show the virtual pad pairing modal
   */
  function showVPadPairingModal () {
    openModal({
      type: ModalTypes.LATERAL,
      content: <VPadPairingModal />
    })
  }

  const statusClass = connectedVPads.length > 0 ? styles.connected : suspendedVPads.length > 0 ? styles.suspended : ''

  return (
    <div
      className={`${styles.vPadBanner} ${connecting ? styles.connecting : ''}`}
      onClick={handleClickBanner}
    >
      <div className={styles.contentWrapper}>
        <VPadIcon className={styles.icon} />
        
        <div className={styles.content}>
          <p className={`bodyTextSmallStrong ${styles.contentTxt}`}>{t('content')}</p>

          <div className={`${styles.statusLabel} ${statusClass}`}>
            <div className={styles.ellipse}></div>
            <p className={`bodyTextSmallStrong ${styles.statusTxt}`}>
              {connectedVPads.length > 0
                ? t('vPadStatus.connected')
                : suspendedVPads.length > 0
                  ? t('vPadStatus.suspended')
                  : t('vPadStatus.unpaired')
              }
            </p>
          </div>
        </div>
      </div>

      <RightChevronIcon className={styles.icon} />
    </div>
  )
}